export default __webpack_public_path__ + "static/media/24443ca8d2731048520cb2016886f0de.png";